import RoomHead from './Head';
import RoomCart from './Card';
import RoomList from './List';
import './style';

const Room = {
    Head: RoomHead,
    Cart: RoomCart,
    List: RoomList
}

export default Room;
